import { render, staticRenderFns } from "./BookingArticleTable.vue?vue&type=template&id=95406d94&scoped=true&"
import script from "./BookingArticleTable.vue?vue&type=script&lang=js&"
export * from "./BookingArticleTable.vue?vue&type=script&lang=js&"
import style0 from "./BookingArticleTable.vue?vue&type=style&index=0&id=95406d94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95406d94",
  null
  
)

export default component.exports